module.exports = __webpack_public_path__ + "static/media/img_feature_photo2.f4e986ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_feature_photo2.png
// module id = 796
// module chunks = 0